import useExercises from "providers/ExercisesProvider/useExercises";
import { useMemo } from "react";

function useExercise(id: string | undefined | null) {
  const exercises = useExercises();
  return useMemo(() => id && exercises.find((exercise) => exercise.id === id), [exercises, id]) || null;
}
export default useExercise;
